export default {
    name: 'ObservedEvidenceDinamicDialog',
    data() {
        return {
            loadingSave: false,
            valid: false,
            listError: [],
            commentRules: [
                (v) => !!v || 'Comentario es requerido',
                // (v) => v.length <= 400 || 'Comentario debe tener menos de 400 caracteres',
            ],
            confirmObservedForm: {
                company_id: null,
                evidence_action_plan_id: null,
                observed: true,
                comment: null
            }
        };
    },
    props: {
        value: Boolean,
        item: Object,
    },
    created() {

    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
    methods: {
        close() {
            this.dialog = false;
            this.$refs?.form?.resetValidation();
            this.listError = [];
        },

        confirmObservedEvidence() {
            if (!this.$refs?.form?.validate()) return;
            this.loadingSave = true;
            this.confirmObservedForm.company_id = parseInt(localStorage.getItem("company_id"));
            this.confirmObservedForm.observed = true;
            this.confirmObservedForm.evidence_action_plan_id = this.item.id;
            this.$emit('confirm', { ...this.confirmObservedForm });
            this.close();
        },

        dialogInput(value) {
            this.$nextTick(() => {
                this.$refs.dialogForm.$el.blur();
                this.$refs.form.resetValidation();
                this.dialog = value;
                if (!value) {
                    this.confirmObservedForm = {
                        company_id: '',
                        evidence_action_plan_id: '',
                        // observed: true,
                        comment: ''
                    }

                }
            })
        },
    },
};
